import AudioCubeApiCallerInstance from "../utils/AudioCubeApiCallerInstance";
import { SOUNDBOX_API_ENDPOINTS } from "../URLConstants";

export const AddLanguage = async(organizationId, shortCode, language, languageURL) =>{
        
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.DEVICE_LANGUAGE,{
                "language": language,
                "shortCode": shortCode,
                "languageUrl": languageURL,
                "organizationId": organizationId            
        })
        return response;
   
}

export const GetLanguageList = async(limit, pageNo, where)=>{
        const response = await AudioCubeApiCallerInstance.get(`${SOUNDBOX_API_ENDPOINTS.DEVICE_LANGUAGE}?limit=${limit}&page=${pageNo}`, {
                params: {
                        "where": JSON.stringify(where),
                    }
        })
        return response;
}

export const UpdateDeviceLanguage = async(deviceId, shortCode)=>{
        const response = await AudioCubeApiCallerInstance.post(SOUNDBOX_API_ENDPOINTS.UPDATE_DEVICE_LANGUAGE, {
                "deviceId": deviceId,
                "shortCode": shortCode
        })
        return response;
}